/**
 * @generated SignedSource<<77646a2cce12e49c1952d673ed655fd8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TagFragment$data = {
  readonly name: string;
  readonly " $fragmentType": "TagFragment";
};
export type TagFragment$key = {
  readonly " $data"?: TagFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TagFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TagFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Tag",
  "abstractKey": null
};

(node as any).hash = "dd735f7f6e028c52d86cc9a2a4eb386a";

export default node;
